import React from "react";
import { ContextMenuContextType } from "./types";

export const ContextMenuContext = React.createContext<ContextMenuContextType>({
  handleClose: () => {},
});
